import React from 'react';
import chevLeft from 'icons/chevron-left-24.png';
import { useNavigate } from 'react-router-dom';

export default function ImportAll() {
  console.log('ImportAll');
  const navigate = useNavigate();

  async function loadAllData(json) {
  }

  async function handleImport() {
    const json = await loadAllData();
    console.log(json);
    //importData(json);
  }

  function importData(data) {
    const jsonString = `data:text/json;chatset=utf-8,${data}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "itookitwhen.json";
    link.click();
  };

  async function readFile(e) {
    const reader = new FileReader();
    reader.onload = async (e) => { 
        const text = (e);
        console.log(text);
        alert(text);
    };
    reader.readAsText(e.target.files[0]);
}
  function fileChange(e) {
    e.preventDefault();
    let data = '';
    let input = document.getElementById("file-name"); 
    console.log('input', input.files[0]);
    let fReader = new FileReader();
    fReader.readAsText(input.files[0]);
    fReader.onloadend = function(event){
        data = event.target.result;
        console.log('fileChange', data);
    }
  }

  return (
    <div className='mcard'>
      <div className='mcard-screen flex justify-between h-100'>
        <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
          <img src={chevLeft} alt='' />
        </div>
        <div className='w-full pl-4'>
          <div className='text-xl '>Import All Data to JSON</div>
        </div>
      </div>
      <div className='flex flex-rpw justify-center'>
        <div>
            <input 
                id='file-name'
                name='file-name'
                type='file' 
                accept='.json' 
                onChange={(e)=>fileChange(e)} />
        </div>
      </div>
      <div className='w-full h-full pt-40 flex justify-center'>
        <button 
          className='rawBtn w-60 h-8 bg-blue-400'
          onClick={()=>handleImport()}
        >
          Import All Data
        </button>
      </div>
    </div>
  );
}
